import { useTranslation } from 'react-i18next';
import { MonitorSmartphone } from 'lucide-react';
import { useSessioneAltrove } from '../../hooks/useSessioneAltrove';
import { riprendiSessioneQui } from '../../services/socket';
import './AvvisoAltroDispositivo.css';

/**
 * «Aperto su un altro dispositivo» — con «Usa qui».
 *
 * Un account ha una connessione sola: quando se ne apre una seconda, il server
 * chiude la prima. Fino a qui la schermata chiusa non diceva NIENTE: sembrava
 * viva, e mosse, sfide, lobby e chat smettevano di arrivare senza una parola.
 *
 * Non si richiude e non sparisce da sola: dura esattamente quanto la sessione
 * sta altrove. «Usa qui» la riprende — il server chiude allora l'altro
 * dispositivo, dove compare lo stesso avviso.
 */
export default function AvvisoAltroDispositivo() {
  const { t } = useTranslation();
  const sessioneAltrove = useSessioneAltrove();

  if (!sessioneAltrove) return null;

  return (
    <div className="avviso-altro-dispositivo" role="alert" data-testid="avviso-altro-dispositivo">
      <span className="aad-icona" aria-hidden="true"><MonitorSmartphone size={18} /></span>
      <span className="aad-testo">
        <span className="aad-titolo">{t('online.sessioneAltrove.titolo', 'Open on another device')}</span>
        <span className="aad-corpo">
          {t('online.sessioneAltrove.corpo', 'You opened the game somewhere else, so this window no longer receives moves or challenges.')}
        </span>
      </span>
      <button type="button" className="aad-usa-qui" onClick={() => { riprendiSessioneQui(); }}>
        {t('online.sessioneAltrove.usaQui', 'Use here')}
      </button>
    </div>
  );
}
